import script from "./ModernColorPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ModernColorPicker.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__